import queryString from 'query-string'

import { Direction, EnvelopeDirection } from '@app/const/consts'
import { Path } from '@app/const/paths'
import { IParams } from '@app/types'
import { IUserFilter } from '@services/userFilters/types'

export const USER_FILTERS_UPDATED_EVENT = 'userFiltersUpdated'

export const USER_FILTER_TITLE_MAX_LENGTH = 20

const sortUserFilterParams = (itemLeft: string, itemRight: string): number =>
  itemLeft.localeCompare(itemRight)

export const getUserFilterRoute = (
  boxOguid: string,
  direction: EnvelopeDirection | Direction
): string =>
  Path.ENVELOPES_BOX_OGUID
    .replace(':boxOguid', boxOguid)
    .replace(':directionOrFolder', direction.toLowerCase())

export const getUserFilterParams = (params: IParams): string =>
  queryString.stringify(params, { sort: sortUserFilterParams })

export const normalizeUserFilterParams = (params: string): string => {
  const parsedParams = queryString.parse(params)

  delete parsedParams.page
  delete parsedParams.perPage

  return queryString.stringify(parsedParams, { sort: sortUserFilterParams })
}

export const getUserFilterUrl = ({ params, route }: IUserFilter): string =>
  params ? `${route}?${params}` : route

export const notifyUserFiltersUpdated = (): void => {
  window.dispatchEvent(new Event(USER_FILTERS_UPDATED_EVENT))
}
